import Vue from 'vue';

import { initialState } from './state';
import StoreModuleService from '../StoreModuleService';

const updateOrCreateEmailTemplates = ({ Vue, state, emailTemplate }) => Vue.set(state.templates, emailTemplate.id, emailTemplate);

// mutations declarations
export const ADD_EMAIL_TEMPLATE = 'ADD_EMAIL_TEMPLATE';
export const DELETE_EMAIL_TEMPLATE = 'DELETE_EMAIL_TEMPLATE';
export const UPDATE_EMAIL_TEMPLATE = 'UPDATE_EMAIL_TEMPLATE';
export const SET_EMAIL_TEMPLATES = 'SET_EMAIL_TEMPLATES';
export const SET_PUBLIC_EMAIL_TEMPLATES = 'SET_PUBLIC_EMAIL_TEMPLATES';
export const SET_SELECTED_EMAIL_TEMPLATE_ID = 'SET_SELECTED_EMAIL_TEMPLATE_ID';

const mutations = {
	...StoreModuleService.createDefaultMutations({ initializer: initialState }),
	[DELETE_EMAIL_TEMPLATE](state, emailTemplateId) {
		Vue.delete(state.templates, emailTemplateId);
	},
	[ADD_EMAIL_TEMPLATE](state, emailTemplate) {
		updateOrCreateEmailTemplates({ Vue, state, emailTemplate });
	},
	[UPDATE_EMAIL_TEMPLATE](state, emailTemplate) {
		updateOrCreateEmailTemplates({ Vue, state, emailTemplate });
	},
	[SET_EMAIL_TEMPLATES](state, emailTemplates) {
		Vue.set(state, 'templates', emailTemplates);
	},
	[SET_PUBLIC_EMAIL_TEMPLATES](state, publicEmailTemplates) {
		Vue.set(state, 'publicEmailTemplates', publicEmailTemplates);
	},
	[SET_SELECTED_EMAIL_TEMPLATE_ID](state, templateId) {
		Vue.set(state, 'selectedEmailTemplateId', templateId);
	},
};

export default mutations;
